
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/why-partner",
      function () {
        return require("private-next-pages/egypt/why-partner.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/why-partner"])
      });
    }
  